import { comments } from '@/mocks/comments';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              读者热评
            </h2>
            <p className="text-sm text-foreground-500 mt-1">百万瓜友的真实声音</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
            共 12,847 条评论
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-background-300 transition-colors"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                    {item.tag && (
                      <span className="text-[10px] bg-primary-100 text-primary-700 px-1.5 py-0.5 rounded">
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>

              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-share-forward-line"></i>
                  分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}